import { TThunkAction } from '../../types/redux';
import { notify } from '../../actions/notifications';
import { ENotificationStyle } from '../../types/notifications';
import { fetchUpdateFolder, IUpdateFolderRequest } from '../../repositories/favorites/v1/update-folder';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { refreshFolders } from '.';

export const updateFolder = (parameters: IUpdateFolderRequest): TThunkAction<Promise<void>> => async (
  dispatch,
  getState,
  { httpApi, logger },
) => {
  const showError = () => dispatch(notify('Не удалось переименовать подборку', ENotificationStyle.Error));

  try {
    const { statusCode, response } = await fetchUpdateFolder({ httpApi, parameters });

    if (statusCode === 200) {
      dispatch(fetchFavoriteEntities({ offset: 0 }));
      dispatch(refreshFolders());
    }

    if (statusCode === 400) {
      showError();
      logger.warning(response.message);
    }
  } catch (e) {
    showError();
    logger.error(e, {
      description: 'Fail to update folder',
    });
  }
};
